import debug from 'debug'
const dbg = debug('settings:helper')

function urlProc (input, fn) {
  if (!input) return null
  try {
    const url = new URL(input)
    return fn(url)
  } catch (err) {
    dbg('Failed to parse URL: %o', err.message)
    return null
  }
}

export function keyFromURL (inputURL) {
  return urlProc(inputURL, (url) => {
    const res = /users\/([^/]+)\/can_watch_users$/.exec(url.pathname)
    return res && res[1]
  })
}

export function lastInURLPAth (inputURL) {
  return urlProc(inputURL, (url) => {
    const key = url.pathname.split('/').pop()
    return key || null
  })
}

export function UsersListByFeature (data) {
  return ResolveAllSettedList(data, keyFromURL)
}

export function SettingListByFeature (data) {
  return ResolveAllSettedList(data, lastInURLPAth)
}

export function ResolveAllSettedList (data, fnGetKey) {
  const list = {}
  const errors = []
  for (const feature of data) {
    if (feature.status === 'rejected') {
      const key = fnGetKey(feature.reason?.config?.url)
      const reason = feature.reason?.response?.data?.type || feature.reason?.message
      errors.push(`Rejected for '${key}': ${reason}`)
      continue
    }

    if (!feature.value) {
      // ignore empty valuies discarded by permissions
      continue
    }
    // fulfilled
    const key = fnGetKey(feature.value?.config?.url)
    if (!key) {
      errors.push('Invalid url key for feature')
      continue
    }
    list[key] = feature.value?.data || []
  }

  return { list, errors }
}

export function UsersListByExten (inputList) {
  const list = {}

  for (const [feature, users] of Object.entries(inputList)) {
    for (const user of users) {
      const key = user.username
      if (!key) {
        dbg('Invalid user in list: %o', user)
        continue
      }
      if (!list[key]) {
        list[key] = { ...user, features: [] }
      }
      list[key].features.push(feature)
    }
  }
  return list
}
